import React from 'react'
import { Route } from 'react-router-dom'

import { QuoPrintPreview,DelPrintPreview,RecPrintPreview,POPrintPreview } from '../components/print'


export const PrintRouter = (<>
  <Route path="/quo-print/:code/:print?" element={<QuoPrintPreview />} />
  <Route path="/delivery/:code/:print?" element={<DelPrintPreview />} />
  <Route path="/receipt/:code/:print?" element={<RecPrintPreview />} />
  <Route path="/purchase-order/:code/:print?" element={<POPrintPreview />} />
</>)